class BulldeskInternalForm {
  constructor(settings) {
    settings.dom = document; // WIP

    this.form = settings.form;
    this.settings = settings;

    if (this.settings.fb_pixel_id) {
      try {
        this.loadFacebookPixel();
      } catch (e) {
        console.warn(e);
      }
    }

    this.withjQuery(() => {
      if (typeof jQuery.fn.mask === 'undefined') {
        this.load(
          'https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.13.4/jquery.mask.min.js',
        );
      }

      jQuery(this.settings.dom).ready(this.bindForm());
    });
  }

  loadFacebookPixel() {
    if (typeof fbq === 'undefined') {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      );

      fbq('init', this.settings.fb_pixel_id);
    }

    fbq('track', 'PageView', {
      content_name: this.settings.identifier,
      content_category: this.settings.identifier,
    });
  }

  withjQuery(callback) {
    if (typeof window.jQuery === 'undefined') {
      this.load(
        'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.1/jquery.min.js',
        callback,
      );
    } else {
      callback();
    }
  }

  load(source, callback) {
    const head = this.settings.dom.getElementsByTagName('head')[0];
    const script = this.settings.dom.createElement('script');

    script.type = 'text/javascript';
    script.src = source;
    // most browsers
    script.onload = callback;
    // IE 6 & 7
    script.onreadystatechange = function () {
      if (this.readyState === 'complete') {
        callback();
      }
    };
    head.appendChild(script);
  }

  bindForm() {
    const me = this;
    const form = jQuery(`#form-${this.form}`);
    const formSubmit = form.find('.bulldesk-submit');
    const formResponse = jQuery(`#bulldesk-form-${this.form}-response`);

    formSubmit.show();

    form.on('submit', (e) => {
      e.preventDefault();

      // Set the client and domain if available
      if (window.BulldeskSettings) {
        me.setHiddenInputs('client', window.BulldeskSettings.client);
        me.setHiddenInputs('domain', window.BulldeskSettings.domain);
      }

      form.find('.text-danger').remove();
      formSubmit.attr('disabled', 'disabled');

      const data = me.getData(form);
      const btn = formSubmit.text();

      jQuery
        .post(form.attr('action'), data)
        .done(function (response) {
          window.location.hash = '';

          try {
            fbq('track', 'Lead', {
              content_name: this.settings.identifier,
              content_category: this.settings.identifier,
            });
          } catch (e) {
            console.warn(e);
          }

          switch (response.form.action) {
            case 'redirect':
              if (response.compiled_action_content) {
                window.location = response.compiled_action_content;

                return;
              }
              break;

            case 'message':
              if (response.compiled_action_content) {
                formResponse.html(response.compiled_action_content);
              }

              if (typeof window.BulldeskSuccessCallback === 'function') {
                const callback = (function () {
                  window.BulldeskSuccessCallback();
                })();
              }

              formResponse.fadeIn();
              break;
          }

          formSubmit.removeAttr('disabled').text(btn);

          form.fadeOut(() => {
            formResponse.fadeIn();

            window.location.hash = `#bulldesk-form-${me.form}-response`;
          });
        })
        .fail((request) => {
          const response = request.responseJSON;

          for (const key in response) {
            let element = form.find(`[name='question[${key}][other]']`);

            if (!element.length) {
              element = form.find(`[name='question[${key}][option]']`);
            }

            if (!element.length) {
              element = form.find(`[name='question[${key}][option][]']`);
            }

            if (!element.length) {
              element = form.find(`[name='question[${key}]']`);
            }

            if (typeof element != 'undefined') {
              const pl = element.closest('.form-group');

              pl.after(
                `<p class="bulldesk-error-message text-danger" style="margin-top: 5px">${response[key]}</p>`,
              );
            }
          }

          formSubmit.before(
            '<p class="bulldesk-error-message text-danger" style="margin-top: 2px">Verifique os erros de validação acima.</p>',
          );

          formSubmit.removeAttr('disabled').html(btn);
        });

      return false;
    });
  }

  getData(form) {
    const data = form.serializeArray();
    // let data = form.serialize();

    // console.log(form);
    // console.log(data);
    // let data = form.find(':input');

    try {
      data.push({
        name: 'salesflow-client',
        value: window.BulldeskSettings.client,
      });
    } catch (e) {
      console.warn(e);
      console.warn('Bulldesk client not found.');
    }

    try {
      data.push({
        name: 'salesflow-domain',
        value: window.BulldeskSettings.domain,
      });
    } catch (e) {
      console.warn(e);
      console.warn('Bulldesk domain not found.');
    }

    return data;
  }

  /**
   * Set the client inputs.
   */
  setHiddenInputs(name, value) {
    if (value === 'undefined') {
      return;
    }

    let inputs = document.getElementsByName(`salesflow-${name}`);
    if(!inputs.length) {
      inputs = document.getElementsByName(`bulldesk-${name}`)
    }

    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].type === 'hidden') {
        inputs[i].value = value;
      }
    }
  }
}

window.BulldeskInternalForm = BulldeskInternalForm;
